import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NewMapsComponent } from './new-maps.component';


const routes: Routes = [{path:'',component:NewMapsComponent}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class NewMapsRoutingModule { }
